import { render, staticRenderFns } from "./ResellerPage.vue?vue&type=template&id=30bac7dd"
import script from "./ResellerPage.vue?vue&type=script&lang=js"
export * from "./ResellerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports